import { useSelector } from 'react-redux';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useState } from 'react';
import DeliveryLocation from '../../DeliveryLocation';

const Location = () => {
	const user = useSelector((store) => store?.user);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const handleClick = async () => {
		setIsShowBottomSheet(true);
	};

	return (
		<>
			<div className='px-4 py-2 flex items-center space-y-2' onClick={handleClick}>
				<div>
					<div className='text-xs font-normal text-gray-600'>Your Location</div>
					<div className='text-xs font-semibold text-gray-800 line-clamp-1'>{user?.address}</div>
				</div>
				<div className='p-2'>
					<ChevronDownIcon className='h-auto w-3.5 text-gray-700' strokeWidth={3} />
				</div>
			</div>
			<div className='border-t-1 border-solid border-gray-200 mx-4' />
			<BottomSheet
				key={'select-location'}
				open={isShowBottomSheet}
				onDismiss={handleCloseBottomSheet}
				snapPoints={({ minHeight, maxHeight }) => {
					return [minHeight, maxHeight * 0.75];
				}}>
				<DeliveryLocation onClose={handleCloseBottomSheet} />
			</BottomSheet>
		</>
	);
};

export default Location;
